// extracted by mini-css-extract-plugin
export default {"transformOpen":"VQbsVPxAHEPdr2wjLTj-qA==","transformClose":"iTptDh21WhmtfEeB3Ycikg=="};